module.exports = "/images/vendor/vue2vis/dist/leftArrow.png?8965662a4348c548189b97493c21a19e";